import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/fa/heart-solid.svg")